module.exports = __webpack_public_path__ + "assets/img/1-2.7c53f76b.png";